
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.72 20.683c-.924 0-1.68.747-1.68 1.659S5.796 24 6.72 24c.924 0 1.68-.746 1.68-1.658 0-.912-.756-1.659-1.68-1.659zM1.68 5.76C.756 5.76 0 6.506 0 7.418c0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.658 0-.912-.756-1.658-1.68-1.658zm0 4.974c-.924 0-1.68.746-1.68 1.659 0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.659 0-.912-.756-1.658-1.68-1.658zm0 4.975c-.924 0-1.68.746-1.68 1.658 0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.658 0-.912-.756-1.658-1.68-1.658zm10.08-6.633c.924 0 1.68-.746 1.68-1.658 0-.912-.756-1.658-1.68-1.658-.924 0-1.68.746-1.68 1.658 0 .912.756 1.658 1.68 1.658zM6.72 15.71c-.924 0-1.68.746-1.68 1.658 0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.658 0-.912-.756-1.658-1.68-1.658zm5.04 0c-.924 0-1.68.746-1.68 1.658 0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.658 0-.912-.756-1.658-1.68-1.658zm0-4.975c-.924 0-1.68.746-1.68 1.659 0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.659 0-.912-.756-1.658-1.68-1.658zm-5.04 0c-.924 0-1.68.746-1.68 1.659 0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.659 0-.912-.756-1.658-1.68-1.658zm0-4.974c-.924 0-1.68.746-1.68 1.658 0 .912.756 1.658 1.68 1.658.924 0 1.68-.746 1.68-1.658 0-.912-.756-1.658-1.68-1.658z","fill":"#263238"}}),_c('circle',{attrs:{"cx":"14.68","cy":"8","r":"7.5","fill":"#21BA45","stroke":"#F1F8FE"}}),_c('path',{attrs:{"d":"M18.022 8.477h-2.864v2.864h-.954V8.477H11.34v-.954h2.864V4.659h.954v2.864h2.864v.954z","fill":"#fff"}})])
          )
        }
      }
    